import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "../i18n";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.split("-")[0] || "en";

  return (
    <div className="flex items-center gap-1 rounded-full border border-border bg-secondary/50 p-0.5" data-testid="language-switcher">
      <Languages className="ml-2 mr-0.5 h-3.5 w-3.5 text-muted-foreground" />
      {SUPPORTED_LANGUAGES.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => i18n.changeLanguage(l.code)}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${
            current === l.code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
};
